import React, { useContext } from 'react';
// import AppImage from '../AppImage';
import styles from './styles.module.scss';
import checkCircle from '../../../../assets/imgs/login/checkCircle.svg';
import { AdminContext } from '../../context/AdminContext';
// import AppImage from '../AppImage';
// import { AdminContext } from '../../../context/AdminContext';
// import { useContext } from 'react';

const SignUpSuccess = ({
  setLevel2,
  setLevel3,
  setLoginModal,
  setForgetPasswordModal,
}) => {
  // const { setForgetPasswordModal, setShowModal } = useContext(AdminContext);
  const { content } = useContext(AdminContext);
  const goToLogin = () => {
    setForgetPasswordModal(false);
    setLoginModal(true);
  };
  return (
    <div
      className={`flex flex-col justify-start items-center w-auto h-auto mt-[10px] ${styles.forgetContainer}`}
    >
      {/* <AppImage src={checkCircle} alt="checked" width={60} height={60} /> */}
      <p className={styles.text}>{content?.forgetPassword?.success?.title}</p>
      <p className={styles.textNote}>
        {content?.forgetPassword?.success?.description}
      </p>
      <button
        className={`${styles.submitItem} ${styles.upload} mainBg`}
        onClick={() => {
          goToLogin();
        }}
      >
        <span>{content?.forgetPassword?.success?.button}</span>
      </button>
    </div>
  );
};

export default SignUpSuccess;
